import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=e7d258bc&scoped=true&"
import script from "./order-item.vue?vue&type=script&lang=js&"
export * from "./order-item.vue?vue&type=script&lang=js&"
import style0 from "./order-item.vue?vue&type=style&index=0&id=e7d258bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d258bc",
  null
  
)

export default component.exports